import { Link } from "react-router-dom";
import type { ReactNode } from "react";

type TextLinkProps = {
  to: string;
  children: ReactNode;
  external?: boolean;
  className?: string;
  /** Só ícone: sem tipografia mono/uppercase; área tocável confortável. */
  variant?: "default" | "icon";
  "aria-label"?: string;
};

const textStyles =
  "font-mono text-[calc(0.6875rem+0.05vw)] uppercase tracking-[0.18em] text-ink-tertiary transition-colors hover:text-accent";

const iconStyles =
  "inline-flex size-10 items-center justify-center rounded-md text-ink-tertiary transition-colors hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/35 focus-visible:ring-offset-2 focus-visible:ring-offset-canvas";

export function TextLink({
  to,
  children,
  external,
  className = "",
  variant = "default",
  "aria-label": ariaLabel,
}: TextLinkProps) {
  const c = `${variant === "icon" ? iconStyles : textStyles} ${className}`.trim();
  if (external) {
    return (
      <a
        href={to}
        className={c}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel}
      >
        {children}
      </a>
    );
  }
  return (
    <Link to={to} className={c} aria-label={ariaLabel}>
      {children}
    </Link>
  );
}
